import {useAtomValue} from 'jotai';
import {zoomLevelAtom} from '@/map/atom';
import {MAX_VISIBLE_ZOOM_METER} from '@/map/constants';
import {getZoomLevel} from '../utils';

export const useVisibleZoomLevel = (
  zoomMeterLimit: number = MAX_VISIBLE_ZOOM_METER.default
) => {
  const curZoom = useAtomValue(zoomLevelAtom);

  if (zoomMeterLimit === -1) {
    return true;
  }

  return curZoom >= getZoomLevel(zoomMeterLimit);
};
